import React from 'react';

import { Chip } from '@mui/material';

interface AppealChipProps {
  /** 1-indexed attempt count (1 = first submission, 2 = first appeal). */
  attemptNumber: number | null | undefined;
}

/**
 * Renders a warning chip labelled "Appeal #N" for appeal attempts.
 * Returns null for first submissions (attempt 1) and missing values.
 */
export default function AppealChip({ attemptNumber }: AppealChipProps) {
  if (!attemptNumber || attemptNumber <= 1) return null;
  return <Chip label={`Appeal #${attemptNumber - 1}`} size="small" color="warning" />;
}
